import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import { AvailablePlan, PublicPlanItem } from './plan-service-types'
import { formatAvailablePlans } from './plan-service-utils'

export const createPlanService = (client = httpServiceClient) => ({
  async fetchAvailablePlans(): Promise<AvailablePlan[]> {
    const response = await client<PublicPlanItem[]>({
      method: 'get',
      url: makeApiUrl('/public/plans'),
      skipAuthRedirect: true
    })

    return formatAvailablePlans(response.body.data as PublicPlanItem[])
  }
})

export const planService = createPlanService()
